export function render(container, html) {
    const range = document.createRange();
    range.setStart(document.documentElement, 0);
    const fragment = range.createContextualFragment(html);
    container.appendChild(fragment);
}
